export default "__VITE_ASSET__BGQ6QUUc__"